import { Button, Tabs } from "antd";

import { useState } from "react";

import { useSelector } from "react-redux";

import ActivateDeviceModal from "./ActivateDeviceModal";

import "./_style.scss";
import ActivationEditor from "../../editors/ActivationEditor";
import DirectActivation from "./DirectActivation";
import CouponActivation from "./CouponActivation";

import style from "./style/payment.module.scss";
import TEXT from "../../config/text";
import useTranslation from "../../hooks/useTranslation";

/**
 *  The page is meant for MAC address-based device activation.
 * @returns
 */

export default function ActivationPage() {
  //   const navigate = useNavigate();
  const translation = useTranslation();
  const { widgets, webSettings } = useSelector((state) => state.globalState);

  const { isAdmin } = useSelector((store) => store.globalState);

  const [visibleActivateDeviceModal, setVisibleActivateDeviceModal] =
    useState(false);

  const { background_color, background_image } = webSettings?.pages?.activation;

  const pageStyle = {
    backgroundColor: background_color,
    backgroundImage: `url(${background_image})`,
    backgroundSize: "cover",
  };

  const handleText = (text) => {
    if (translation?.pages?.activation?.[text]) {
      return translation?.pages?.activation?.[text];
    }

    return TEXT?.pages?.activation?.[text];
  };

  const handleTelegramRedirect = () => {
    const telegramURL = "https://t.me/beeplayersmaert";
    window.open(telegramURL, "_blank");
  };

  return (
    <div className="page-wrapper" style={pageStyle}>
      {isAdmin && <ActivationEditor />}
      <div className={style["page-container"]}>
        <Tabs
          centered={true}
          tabBarStyle={{
            color: "white",
            marginTop: 20,
            margin: "auto",
            width: "350px",
          }}
          destroyInactiveTabPane
        >
          <Tabs.TabPane key="1" tab={handleText("direct_pay")}>
            <DirectActivation />
          </Tabs.TabPane>
          {widgets?.coupons?.enabled === "true" && (
            <Tabs.TabPane tab={handleText("gift_code")} key="2">
              <CouponActivation />
            </Tabs.TabPane>
          )}
        </Tabs>
      </div>

      <div className="activate-device">
        {/* telegram */}
        <div className="container-btn-telegram">
          <button
            onClick={handleTelegramRedirect}
            className="connect-btn"
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              style={{
                width: "50px",
                height: "50px",
                marginLeft: "0.5rem",
              }}
            >
              <circle cx="24" cy="24" r="24" fill="#229ED9"/>
              <path
                fill="#fff"
                d="M10.9 23.3c6.5-2.8 10.8-4.7 13-5.6 6.2-2.6 7.5-3 8.3-3 .2 0 .6 0 .9.3.2.2.3.5.3.7 0 .2 0 .5-.1.7-.5 5.1-2.5 17.4-3.6 23.1-.5 2.4-1.4 3.2-2.2 3.3-1.9.2-3.3-1.2-5.1-2.4-2.8-1.9-4.4-3-7.2-4.8-3.2-2.1-.3-3.3 1.4-5.2.5-.5 8.5-7.8 8.7-8.5 0-.1 0-.3-.1-.4-.2-.1-.4-.1-.6 0-.2.1-4.1 2.6-11.5 7.7-1.1.7-2.1 1.1-3 1.1-1 0-2.9-.6-4.3-1-1.7-.6-3.1-.9-3-1.9.1-.5.8-1 2.1-1.6z"
              />
            </svg>
          </button>
        </div>
        <section className="activation-section">
          <p className={style["text-voucher"]}>
            {handleText("activate_for_qa_description")}
          </p>

          <Button onClick={() => setVisibleActivateDeviceModal(true)}>
            {handleText("activate_qa_button_text")}
          </Button>
        </section>
      </div>

      {visibleActivateDeviceModal && (
        <ActivateDeviceModal
          visible={visibleActivateDeviceModal}
          onClose={() => setVisibleActivateDeviceModal(false)}
        />
      )}
    </div>
  );
}
